<template>
  <v-bottom-navigation
  fixed
  grow
  dense
  app
  color="#e00000"
  >
    <v-btn to="/dashboard">
      <span>Home</span>
     <v-icon>mdi-home-variant</v-icon>
    </v-btn>

    <v-btn  to="/subscribers">
      <span>Subscribers</span>
      <v-icon>mdi-account-group</v-icon>
    </v-btn>

    <v-btn to="/activity">
      <span>Activity</span>
      <v-icon to="/portfolio">mdi-heart-circle</v-icon>
    </v-btn>

    <v-btn to='/settings'>
      <span>Settings</span>

      <v-icon>mdi-account-circle</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
  export default {
    name: 'BottomMenu',

    data: () => ({
     
    }),
  }
</script>


<style>
.btnColor{
  background: linear-gradient(180deg, #008b81 0%, #01675f 100%);
  border-radius:100px
}

</style>